import { InjectionToken } from '@angular/core';
import { MediaAdapterBase } from '../adapter/media-adapter.base';

export const MEDIA_ADAPTER = new InjectionToken<MediaAdapterBase>('MediaAdapter');
